document.addEventListener('DOMContentLoaded', function () {
  const containers = document.querySelectorAll('.product__media-list__container--large');

  containers.forEach(function (container) {
    const items = container.querySelectorAll('.product__media-item');
    if (items.length <= 1) return;

    // Crear puntitos
    const dots = document.createElement('div');
    dots.style.cssText = 'display:flex;justify-content:center;gap:8px;padding:12px 0;';

    items.forEach(function (_, i) {
      const dot = document.createElement('span');
      dot.style.cssText = 'width:8px;height:8px;border-radius:50%;background:#ccc;cursor:pointer;transition:background 0.3s;';
      if (i === 0) dot.style.background = '#000';
      dot.addEventListener('click', function () {
        items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
      dots.appendChild(dot);
    });

    container.parentNode.insertBefore(dots, container.nextSibling);

    // Actualizar puntito activo al hacer scroll
    container.addEventListener('scroll', function () {
      const index = Math.round(container.scrollLeft / container.offsetWidth);
      dots.querySelectorAll('span').forEach(function (d, i) {
        d.style.background = i === index ? '#000' : '#ccc';
      });
    });
  });
});